import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const ArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M8 15l4 4m4-4l-3.818 3.818M12 18.5V5"
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    />
  </svg>
)
